var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3544 31.7458L42.0634 31.2754H41.7949V32.3895H42.0332V31.6372L42.3409 32.1257H42.362L42.6696 31.6372V32.3895H42.9079V31.2754H42.6485L42.3544 31.7458Z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6426 31.5H40.9744V32.3895H41.2277V31.5H41.561V31.2754H40.6426V31.5Z",
    fill: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7527 29.6236C12.474 29.6236 10.1018 26.9083 10.1018 23.5582V23.5099C10.1018 20.1599 12.4997 17.4687 15.7527 17.4687C17.7102 17.4687 19.1776 18.325 20.547 19.596L22.4803 17.3707C20.841 15.8057 18.9333 14.7051 15.7768 14.7051C10.5904 14.7051 6.94531 18.6914 6.94531 23.5582V23.6079C6.94531 28.5245 10.6643 32.4128 15.6546 32.4128C18.8594 32.4128 20.8169 31.2383 22.6025 29.3808L20.6706 27.4239C19.2017 28.7913 17.8565 29.6236 15.7527 29.6236Z",
    fill: "#D3D3D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0938 27.3726C41.0938 25.0493 39.6988 23.8989 37.693 23.2144C38.9658 22.5541 40.1392 21.4535 40.1392 19.3985V19.3502C40.1392 18.2014 39.7486 17.2712 38.99 16.5128C38.0112 15.5343 36.4699 14.9961 34.5124 14.9961H26.8301V32.1157H34.7567C38.5737 32.1157 41.0938 30.4769 41.0938 27.4193V27.3726ZM29.7905 17.6632H34.1203C36.0537 17.6632 37.129 18.4939 37.129 19.8402V19.89C37.129 21.455 35.832 22.2133 33.9001 22.2133H29.7905V17.6632ZM38.0836 27.1027C38.0836 28.6436 36.8364 29.4502 34.7808 29.4502H29.7905V24.7538H34.5607C36.9344 24.7538 38.0836 25.6101 38.0836 27.053V27.1027Z",
    fill: "#D3D3D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78095 0H0V2.78015V45.2198V48H2.78095H46.219H49V45.2198V2.78015V0H46.219H2.78095ZM46.219 45.2696H2.78095V45.2198V2.78015H46.219V45.2696Z",
    fill: "#D3D3D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2193 45.2209H2.78125V45.2707H46.2193V2.78125V45.2209Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/Logomark.9ae128d6ea86bfc76bd5dc29c16ef0db.svg";
export { ForwardRef as ReactComponent };